import type { FC } from 'react'

import { useQuery } from '@tanstack/react-query'
import Linkify from 'react-linkify'

import queries from '@/api/queries'
import { statsResources } from '@/api/stats'
import { useAppContext } from '@/App.context'
import Page from '@/components/content/Page'
import { Translation } from '@/components/i18n/Translation'
import { useFullUserName, useIsBechtle, useIsMobit, useProfile } from '@/hooks/user'
import { numberFormat } from '@/util/formatters/numbers'

import './home.scss'

export const Home: FC = () => {
  const { whiteLabel } = useAppContext()
  const fullName = useFullUserName()
  const isBechtle = useIsBechtle()

  return (
    <Page className="home">
      <h1>
        <Translation id="Home" />
      </h1>

      <div className="beta-launch-page">
        {isBechtle ? (
          <Translation id="welcome_message_bechtle" userName={fullName} />
        ) : (
          // @ts-ignore
          <Linkify properties={{ target: '_blank' }}>
            <Translation id={`welcome_message_${whiteLabel}`} userName={fullName} />
          </Linkify>
        )}
      </div>

      {!isBechtle && <Stats />}
    </Page>
  )
}

const Stats: FC = () => {
  const { data: stats } = useQuery(queries.stats(), statsResources.get)

  const isMobit = useIsMobit()
  const isTradeInDealer = Boolean(useProfile()?.isTradeInDealer)

  if (!stats) return null

  const { customers, subscriptionOrders, deviceOrders, ecomOrders, tradeInOrders } = stats

  return (
    <div className="data-points">
      <DataPoint textId="Customers" amount={customers} />
      <DataPoint textId="Subscription orders" amount={subscriptionOrders} />
      <DataPoint textId="Device orders" amount={deviceOrders} />
      <DataPoint textId={isMobit ? 'Multicase Orders' : 'Shop Orders'} amount={ecomOrders} />
      {isTradeInDealer && <DataPoint textId="Trade-in orders" amount={tradeInOrders} />}
    </div>
  )
}

const DataPoint: FC<{ textId: string; amount: number }> = ({ textId, amount }) => (
  <div className="data-points__data-point">
    <h2 className="text-base">
      <Translation id={textId} />
    </h2>
    <p>{numberFormat(amount)}</p>
  </div>
)
